import {register} from '@shopify/theme-sections'
import '../../styles/sections/section-brands.scss'
import {createRoot} from "react-dom/client"
import BrandTable from "@/scripts/components/brand-table/BrandTable"
import React from "react"

export default register(`section-brands`, {
    onLoad() {
        let brandsRoot = createRoot(document.querySelector(`#brandsRoot`))
        brandsRoot.render(
            <BrandTable brands={window.shopByBrands}/>
        )
    },
    onUnload() {

    },
})
